export default __webpack_public_path__ + "static/media/OurPeople.aab00bf4.PNG";